export const gapVariants = {
  gap: {
    0: 'gap-0',
    '0.5': 'gap-0.5',
    1: 'gap-1',
    '1.5': 'gap-[0.375rem]',
    2: 'gap-2',
    3: 'gap-3',
    4: 'gap-4',
    5: 'gap-5',
    6: 'gap-6',
    8: 'gap-8',
    10: 'gap-10',
    11: 'gap-11',
    12: 'gap-12',
    16: 'gap-16',
    20: 'gap-20',
    24: 'gap-24',
    32: 'gap-32',
    40: 'gap-40',
    48: 'gap-48',
    56: 'gap-56',
    64: 'gap-64',
  },
  'gap-sm': {
    0: 'sm:gap-0',
    '0.5': 'sm:gap-0.5',
    1: 'sm:gap-1',
    '1.5': 'sm:gap-[0.375rem]',
    2: 'sm:gap-2',
    3: 'sm:gap-3',
    4: 'sm:gap-4',
    5: 'sm:gap-5',
    6: 'sm:gap-6',
    8: 'sm:gap-8',
    10: 'sm:gap-10',
    12: 'sm:gap-12',
    16: 'sm:gap-16',
    20: 'sm:gap-20',
    24: 'sm:gap-24',
    32: 'sm:gap-32',
    40: 'sm:gap-40',
    48: 'sm:gap-48',
    56: 'sm:gap-56',
    64: 'sm:gap-64',
  },
  'gap-md': {
    0: 'md:gap-0',
    '0.5': 'md:gap-0.5',
    1: 'md:gap-1',
    '1.5': 'md:gap-[0.375rem]',
    2: 'md:gap-2',
    3: 'md:gap-3',
    4: 'md:gap-4',
    5: 'md:gap-5',
    6: 'md:gap-6',
    8: 'md:gap-8',
    10: 'md:gap-10',
    12: 'md:gap-12',
    16: 'md:gap-16',
    20: 'md:gap-20',
    24: 'md:gap-24',
    32: 'md:gap-32',
    40: 'md:gap-40',
    48: 'md:gap-48',
    56: 'md:gap-56',
    64: 'md:gap-64',
  },
  'gap-lg': {
    0: 'lg:gap-0',
    '0.5': 'lg:gap-0.5',
    1: 'lg:gap-1',
    '1.5': 'lg:gap-[0.375rem]',
    2: 'lg:gap-2',
    3: 'lg:gap-3',
    4: 'lg:gap-4',
    5: 'lg:gap-5',
    6: 'lg:gap-6',
    8: 'lg:gap-8',
    10: 'lg:gap-10',
    12: 'lg:gap-12',
    16: 'lg:gap-16',
    20: 'lg:gap-20',
  },
  'gap-xl': {
    0: 'xl:gap-0',
    '0.5': 'xl:gap-0.5',
    1: 'xl:gap-1',
    '1.5': 'xl:gap-[0.375rem]',
    2: 'xl:gap-2',
    3: 'xl:gap-3',
    4: 'xl:gap-4',
    5: 'xl:gap-5',
    6: 'xl:gap-6',
    8: 'xl:gap-8',
    10: 'xl:gap-10',
    12: 'xl:gap-12',
    16: 'xl:gap-16',
    20: 'xl:gap-20',
  },
  'gap-x': {
    0: 'gap-x-0',
    '0.5': 'gap-x-0.5',
    1: 'gap-x-1',
    '1.5': 'gap-x-[0.375rem]',
    2: 'gap-x-2',
    3: 'gap-x-3',
    4: 'gap-x-4',
    5: 'gap-x-5',
    6: 'gap-x-6',
    8: 'gap-x-8',
    10: 'gap-x-10',
    12: 'gap-x-12',
    16: 'gap-x-16',
    20: 'gap-x-20',
    24: 'gap-x-24',
    32: 'gap-x-32',
    40: 'gap-x-40',
    48: 'gap-x-48',
    56: 'gap-x-56',
    64: 'gap-x-64',
  },
  'gap-x-sm': {
    0: 'sm:gap-x-0',
    '0.5': 'sm:gap-x-0.5',
    1: 'sm:gap-x-1',
    '1.5': 'sm:gap-x-[0.375rem]',
    2: 'sm:gap-x-2',
    3: 'sm:gap-x-3',
    4: 'sm:gap-x-4',
    5: 'sm:gap-x-5',
    6: 'sm:gap-x-6',
    8: 'sm:gap-x-8',
    10: 'sm:gap-x-10',
    12: 'sm:gap-x-12',
    16: 'sm:gap-x-16',
    20: 'sm:gap-x-20',
    24: 'sm:gap-x-24',
    32: 'sm:gap-x-32',
    40: 'sm:gap-x-40',
    48: 'sm:gap-x-48',
    56: 'sm:gap-x-56',
    64: 'sm:gap-x-64',
  },
  'gap-x-md': {
    0: 'md:gap-x-0',
    '0.5': 'md:gap-x-0.5',
    1: 'md:gap-x-1',
    '1.5': 'md:gap-x-[0.375rem]',
    2: 'md:gap-x-2',
    3: 'md:gap-x-3',
    4: 'md:gap-x-4',
    5: 'md:gap-x-5',
    6: 'md:gap-x-6',
    8: 'md:gap-x-8',
    10: 'md:gap-x-10',
    12: 'md:gap-x-12',
    16: 'md:gap-x-16',
    20: 'md:gap-x-20',
    24: 'md:gap-x-24',
    32: 'md:gap-x-32',
    40: 'md:gap-x-40',
    48: 'md:gap-x-48',
    56: 'md:gap-x-56',
    64: 'md:gap-x-64',
  },
  'gap-x-lg': {
    0: 'lg:gap-x-0',
    '0.5': 'lg:gap-x-0.5',
    1: 'lg:gap-x-1',
    '1.5': 'lg:gap-x-[0.375rem]',
    2: 'lg:gap-x-2',
    3: 'lg:gap-x-3',
    4: 'lg:gap-x-4',
    5: 'lg:gap-x-5',
    6: 'lg:gap-x-6',
    8: 'lg:gap-x-8',
    10: 'lg:gap-x-10',
    12: 'lg:gap-x-12',
    16: 'lg:gap-x-16',
    20: 'lg:gap-x-20',
  },
  'gap-x-xl': {
    0: 'xl:gap-x-0',
    '0.5': 'xl:gap-x-0.5',
    1: 'xl:gap-x-1',
    '1.5': 'xl:gap-x-[0.375rem]',
    2: 'xl:gap-x-2',
    3: 'xl:gap-x-3',
    4: 'xl:gap-x-4',
    5: 'xl:gap-x-5',
    6: 'xl:gap-x-6',
    8: 'xl:gap-x-8',
    10: 'xl:gap-x-10',
    12: 'xl:gap-x-12',
    16: 'xl:gap-x-16',
    20: 'xl:gap-x-20',
  },
  'gap-y': {
    0: 'gap-y-0',
    '0.5': 'gap-y-0.5',
    1: 'gap-y-1',
    '1.5': 'gap-y-[0.375rem]',
    2: 'gap-y-2',
    3: 'gap-y-3',
    4: 'gap-y-4',
    5: 'gap-y-5',
    6: 'gap-y-6',
    8: 'gap-y-8',
    10: 'gap-y-10',
    12: 'gap-y-12',
    16: 'gap-y-16',
    20: 'gap-y-20',
    24: 'gap-y-24',
    32: 'gap-y-32',
    40: 'gap-y-40',
    48: 'gap-y-48',
    56: 'gap-y-56',
    64: 'gap-y-64',
  },
  'gap-y-sm': {
    0: 'sm:gap-y-0',
    '0.5': 'sm:gap-y-0.5',
    1: 'sm:gap-y-1',
    '1.5': 'sm:gap-y-[0.375rem]',
    2: 'sm:gap-y-2',
    3: 'sm:gap-y-3',
    4: 'sm:gap-y-4',
    5: 'sm:gap-y-5',
    6: 'sm:gap-y-6',
    8: 'sm:gap-y-8',
    10: 'sm:gap-y-10',
    12: 'sm:gap-y-12',
    16: 'sm:gap-y-16',
    20: 'sm:gap-y-20',
    24: 'sm:gap-y-24',
    32: 'sm:gap-y-32',
    40: 'sm:gap-y-40',
    48: 'sm:gap-y-48',
    56: 'sm:gap-y-56',
    64: 'sm:gap-y-64',
  },
  'gap-y-md': {
    0: 'md:gap-y-0',
    '0.5': 'md:gap-y-0.5',
    1: 'md:gap-y-1',
    '1.5': 'md:gap-y-[0.375rem]',
    2: 'md:gap-y-2',
    3: 'md:gap-y-3',
    4: 'md:gap-y-4',
    5: 'md:gap-y-5',
    6: 'md:gap-y-6',
    8: 'md:gap-y-8',
    10: 'md:gap-y-10',
    12: 'md:gap-y-12',
    16: 'md:gap-y-16',
    20: 'md:gap-y-20',
    24: 'md:gap-y-24',
    32: 'md:gap-y-32',
    40: 'md:gap-y-40',
    48: 'md:gap-y-48',
    56: 'md:gap-y-56',
    64: 'md:gap-y-64',
  },
  'gap-y-lg': {
    0: 'lg:gap-y-0',
    '0.5': 'lg:gap-y-0.5',
    1: 'lg:gap-y-1',
    '1.5': 'lg:gap-y-[0.375rem]',
    2: 'lg:gap-y-2',
    3: 'lg:gap-y-3',
    4: 'lg:gap-y-4',
    5: 'lg:gap-y-5',
    6: 'lg:gap-y-6',
    8: 'lg:gap-y-8',
    10: 'lg:gap-y-10',
    12: 'lg:gap-y-12',
    16: 'lg:gap-y-16',
    20: 'lg:gap-y-20',
  },
  'gap-y-xl': {
    0: 'xl:gap-y-0',
    '0.5': 'xl:gap-y-0.5',
    1: 'xl:gap-y-1',
    '1.5': 'xl:gap-y-[0.375rem]',
    2: 'xl:gap-y-2',
    3: 'xl:gap-y-3',
    4: 'xl:gap-y-4',
    5: 'xl:gap-y-5',
    6: 'xl:gap-y-6',
    8: 'xl:gap-y-8',
    10: 'xl:gap-y-10',
    12: 'xl:gap-y-12',
    16: 'xl:gap-y-16',
    20: 'xl:gap-y-20',
  },
}
